import angular from 'angular';
import { saveAs } from 'file-saver/FileSaver';
import Sortable from "sortablejs";


let VaccineListController = function (Vaccine, $filter, $scope, $state, $mdDialog, Toast) {
  let $ctrl = this;
  $ctrl.$scope = $scope;

  angular.extend($ctrl, {
    edit, orderList, handleDelete
  });

  activate();

  function activate() {
    $ctrl.resources = {
      count: 0,
      data: []
    };

    $ctrl.uiState = 'LOADING';

    $ctrl.promise;

    $ctrl.$scope.tableConfig = {
      page: 1,
      limit: 10,
      order: 'updated_at DESC',
      like_search: '',
      like_search_fields: [
        'name',
        'short_name'
      ]
    };

    $ctrl.$scope.$watch('tableConfig', () => {
      loadData()
    }, true);

    createSortableList()
  }

  function createSortableList() {
    const el = document.getElementById("items");
    const sortable = Sortable.create(el, { onUpdate: reorderListItems });
  }

  function reorderListItems(event) {
    const { oldIndex, newIndex } = event;
    const listCopy = angular.copy($ctrl.resources.data);
    const id = event.item.getAttribute("data-id");

    Vaccine.updatePosition(id, {
      new_position: listCopy[newIndex].position,
      old_position: listCopy[oldIndex].position,
    })
      .then(function (res) {
        Toast.success($filter('translate')('table-list-new-order'));
      })
      .catch(({ data }) => {
        Toast.error(data.message);
      })
      .finally(() => loadData());

    const elementToMove = $ctrl.resources.data.splice(oldIndex, 1);
    $ctrl.resources.data.splice(newIndex, 0, elementToMove[0]);
  }

  $scope.downloadReport = function () {
    $ctrl.activeSpin = true;
    $ctrl.activeSpinButton = true;
    Vaccine
    .downloadReport()
    .then(function (res) {
      var file = new Blob([res], { type: 'text/csv;charset=utf-8;' });
      let messageSuccess = $filter('translate')('report-success');
      $ctrl.activeSpin = false;
      $ctrl.activeSpinButton = false;
      Toast.success(messageSuccess);
      saveAs(file, 'rel_analitico_vacinas.csv');
    }).catch(err => {
      console.log('err:' ,  err);
      let messageError = $filter('translate')('report-error');
      $ctrl.activeSpin = false;
      $ctrl.activeSpinButton = false;
      Toast.error(messageError);
    });
  };

  function edit(id) {
    $state.go('vaccine.edit', {id});
  }

  function handleDelete(resource, event) {
    event.stopPropagation();

    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')('common-detail-delete-confirm-text'))
      .ariaLabel($filter('translate')('common-detail-delete-confirm-text'))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Vaccine
          .destroy(resource)
          .then(response => {
            Toast.success($filter('translate')('common-detail-delete-success'));
            $ctrl.deleting = false;
            _.remove($ctrl.resources.data, resource);
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:' ,  err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  function orderList(field) {
    var tableConfig = $ctrl.$scope.tableConfig;
    if (tableConfig.order) {
      var currentField = tableConfig.order.split(' ')[0];
      var currentOrder = tableConfig.order.split(' ')[1];

      if (currentField === field) {
        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
        tableConfig.order = currentField + ' ' + currentOrder;
      } else {
        tableConfig.order = field + ' ' + 'ASC';
      }
    } else {
      tableConfig.order = field + ' ' + ' ASC';
    }
  }

  // Local functions

  function loadData() {
    $ctrl.promise = Vaccine
      .load($ctrl.$scope.tableConfig)
      .then(response => {
        setPlaceHolderValues(response.data);
        $ctrl.resources = response;
        $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
        $ctrl.$scope.$apply();
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.uiState = 'ERROR';
      });
  }

  function setPlaceHolderValues(arr) {
  	_.forEach(arr, item => {
  		if (item.short_name === null || item.short_name === undefined) {
  			item.short_name = $filter('translate')('common-not-informed');
  		}
  	});
  }
}

VaccineListController.$inject = ['Vaccine', '$filter', '$scope', '$state', '$mdDialog', 'Toast'];

export default VaccineListController;



// WEBPACK FOOTER //
// ./client/app/components/vaccine/vaccine-list.controller.js